export default {
  // Specific fields
  certification: 'Certification',
  institutional: 'Institutional',
  profiles: 'Profiles',
  startLevel: 'Start Level',
  endLevel: 'End Level',

  // Specific actions
  goToProfile: 'Go to profile',
  fieldNMustNotExceed: 'This field must not exceed 100',

  // Tab titles
  entityData: '{entity} Data',
  assignEntity: 'Assign {entity}',

  // Male messages (for Cycle)
  createdMale: 'created.',
  updatedMale: 'updated.',
  deletedMale: 'deleted.',

  // Relationship messages
  relationshipCreated: 'Relationship between {entity1} and {entity2} created.',
  relationshipUpdated: 'Relationship between {entity1} and {entity2} updated.',
  entityDeletedFromEntity: '{entity1} deleted from {entity2}.',
}
